import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import SEOHead from '@/components/feature/SEOHead';
import { categories, articles, faqs } from '@/mocks/data';

export default function Home() {
  const latestArticles = articles.slice(0, 6);

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '17c.cc每日大赛',
      url: 'https://17c.cc',
      description: '17c.cc每日大赛是17c.cc平台推出的每日竞技活动，覆盖射击、策略、MOBA、格斗、竞速、休闲六大竞技品类。',
      sameAs: ['https://17c.cc'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '17c.cc每日大赛',
      url: 'https://17c.cc',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://17c.cc/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '17c.cc每日大赛 - 每天竞技赢好礼',
      description: '17c.cc每日大赛是17c.cc平台推出的每日竞技活动，玩家每天参与大赛挑战，与全国高手同场竞技，赢取丰厚奖励。',
      url: 'https://17c.cc',
      isPartOf: { '@type': 'WebSite', name: '17c.cc每日大赛', url: 'https://17c.cc' },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ];

  return (
    <>
      <SEOHead
        title="17c.cc每日大赛 - 每天竞技赢好礼 | 在线每日竞技平台"
        description="17c.cc每日大赛是17c.cc平台推出的每日竞技活动，玩家每天参与大赛挑战，与全国高手同场竞技，赢取丰厚奖励。立即加入17c.cc每日大赛，体验刺激竞技乐趣，每天都有新挑战等你来战！"
        keywords="17c.cc每日大赛,17c.cc大赛活动,每日竞技大赛,17c.cc赢奖励,每日挑战赛,17c.cc竞技平台,在线每日赛事"
        schema={schema}
      />
      <Navbar />
      <BackToTop />

      <main>
        {/* Hero Section */}
        <section className="relative h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Epic%20esports%20arena%20with%20dramatic%20golden%20lighting%2C%20grand%20stage%20with%20trophy%20in%20center%2C%20packed%20audience%2C%20warm%20atmosphere%2C%20professional%20gaming%20tournament%20venue%2C%20cinematic%20wide%20shot%2C%20dark%20background%20with%20spotlight%20beams&width=1920&height=900&seq=hero-bg&orientation=landscape"
            alt="17c.cc每日大赛竞技舞台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="relative z-10 text-center px-4 w-full">
            <div className="max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
                <i className="ri-fire-line text-accent-400 text-sm"></i>
                <span className="text-white/90 text-sm font-medium">2026夏季冠军赛火热进行中</span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                每天竞技，<span className="text-accent-400">赢取好礼</span>
              </h1>
              <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
                加入17c.cc每日大赛，与全国高手同场竞技。六大竞技品类，丰厚奖励等你来拿，每天都有新挑战！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="https://17c.cc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer shadow-lg shadow-primary-500/25"
                >
                  立即参赛
                </a>
                <Link
                  to="/about"
                  className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-lg text-base font-medium whitespace-nowrap hover:bg-white/20 transition-all duration-200 cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { value: '200万+', label: '注册玩家', icon: 'ri-user-star-line' },
                { value: '1,000+', label: '每日赛事', icon: 'ri-calendar-check-line' },
                { value: '500万+', label: '总奖金池(元)', icon: 'ri-money-cny-circle-line' },
                { value: '6大', label: '竞技品类', icon: 'ri-stack-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${stat.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-600 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                为什么选择 <span className="text-primary-600">17c.cc每日大赛</span>？
              </h2>
              <p className="text-foreground-600 mt-3 max-w-2xl mx-auto">
                六大核心优势，打造最专业的在线每日竞技平台
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                {
                  title: '每日更新赛事',
                  desc: '每一天都有全新赛事等你来挑战，从不停歇的竞技乐趣，保持新鲜感与挑战性。',
                  icon: 'ri-calendar-event-line',
                },
                {
                  title: '公平匹配机制',
                  desc: '智能算法匹配实力相当的对手，无论新手还是高手都能享受势均力敌的对决体验。',
                  icon: 'ri-scales-line',
                },
                {
                  title: '丰厚奖励体系',
                  desc: '现金奖金、平台积分、限定道具多重奖励，每一次参赛都有机会赢取丰厚回报。',
                  icon: 'ri-gift-line',
                },
                {
                  title: '六大竞技品类',
                  desc: '射击、策略、MOBA、格斗、竞速、休闲，六大赛道覆盖所有竞技爱好者。',
                  icon: 'ri-grid-line',
                },
                {
                  title: '专业反作弊系统',
                  desc: 'AI行为分析+人工审核双重保障，确保每一场比赛都公平公正、干净透明。',
                  icon: 'ri-shield-check-line',
                },
                {
                  title: '活跃玩家社区',
                  desc: '百万玩家同台竞技，结识志同道合的朋友，分享竞技心得，共同成长进步。',
                  icon: 'ri-group-line',
                },
              ].map((feature) => (
                <div key={feature.title} className="p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
                  <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                    <i className={`${feature.icon} text-accent-600 text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                  热门赛事<span className="text-primary-600">分类</span>
                </h2>
                <p className="text-foreground-600 mt-2">六大竞技品类，总有一个适合你</p>
              </div>
              <Link
                to="/category/competitive-shooting"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                查看全部分类 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group relative rounded-lg overflow-hidden h-64 cursor-pointer"
                >
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-8 h-8 rounded-lg bg-accent-500/90 flex items-center justify-center">
                        <i className={`${cat.icon} text-background-50 text-sm`}></i>
                      </div>
                      <span className="text-white/70 text-xs">{cat.articleCount} 篇攻略</span>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-white mb-1">{cat.name}</h3>
                    <p className="text-white/70 text-sm">{cat.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                  最新<span className="text-primary-600">攻略文章</span>
                </h2>
                <p className="text-foreground-600 mt-2">赛事资讯、技巧攻略、玩家故事，一网打尽</p>
              </div>
              <Link
                to="/category/strategy-games"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                查看更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                      <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">{article.category}</span>
                      <span>{article.date}</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                    <div className="flex flex-wrap gap-1.5 mt-3">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span key={tag} className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section id="faq" className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                常见<span className="text-primary-600">问题</span>
              </h2>
              <p className="text-foreground-600 mt-2">关于17c.cc每日大赛，你想知道的都在这里</p>
            </div>
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <details key={index} className="group rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer select-none">
                    <span className="font-medium text-sm text-foreground-900 pr-4">{faq.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 text-lg flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Esports%20arena%20with%20golden%20trophy%20in%20spotlight%2C%20dramatic%20warm%20atmosphere%2C%20victory%20celebration%20mood%2C%20dark%20background%20with%20golden%20particle%20effects%2C%20cinematic%20composition&width=1920&height=600&seq=cta-bg&orientation=landscape"
            alt="加入17c.cc每日大赛"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
          <div className="relative z-10 text-center px-4 w-full">
            <div className="max-w-2xl mx-auto">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
                准备好迎接<span className="text-accent-400">每日挑战</span>了吗？
              </h2>
              <p className="text-white/80 text-base mb-8 max-w-lg mx-auto">
                立即加入17c.cc每日大赛，与全国高手同台竞技，赢取属于你的荣耀与奖励！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="https://17c.cc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer shadow-lg shadow-primary-500/25"
                >
                  立即参赛
                </a>
                <Link
                  to="/about"
                  className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-lg text-base font-medium whitespace-nowrap hover:bg-white/20 transition-all duration-200 cursor-pointer"
                >
                  联系我们
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}